// Need all mappings for PROD
//
// `components/stablecoin-network-notice.tsx` hardcodes customer-facing copy
// naming the networks USDC/USDT settle on (Ethereum, Tron) and their icon
// keys ("TRX" for `trx.png`) independently of this map. A change here — a
// renamed network, a swapped icon file, added Tron support for another
// asset — may need that copy updated too.
export const BLOCKCHAIN_MAPPING = {
  // Ethereum mainnet
  "eip155:1": {
    name: "Ethereum",
    icon: "eth.png",
    ledgerProduct: "ETH",
  },
  // Ethereum testnet
  "eip155:11155111": {
    name: "Ethereum",
    icon: "eth.png",
    ledgerProduct: "ETH",
  },
  // Solana testnet
  "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z": {
    name: "Solana",
    icon: "sol.png",
    ledgerProduct: "SOL",
  },
  "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp": {
    name: "Solana",
    icon: "sol.png",
    ledgerProduct: "SOL",
  },
  "bip122:000000000933ea01ad0ee984209779ba": {
    name: "Bitcoin",
    icon: "btc.png",
    ledgerProduct: "BTC",
  },
  "bip122:000000000019d6689c085ae165831e93": {
    name: "Bitcoin",
    icon: "btc.png",
    ledgerProduct: "BTC",
  },
  "tron:testnet": {
    name: "Tron",
    icon: "trx.png",
    ledgerProduct: "TRX",
  },
  "tron:mainnet": {
    name: "Tron",
    icon: "trx.png",
    ledgerProduct: "TRX",
  },
  "eip155:137": {
    name: "Polygon",
    icon: "pol.png",
    ledgerProduct: "POL",
  },
};
